export default __webpack_public_path__ + "static/media/object-1.b76b8ba3.webp";